import rest from "@/rest-client";

export default {
  moduleName: "synchronization",
  namespaced: true,
  state: () => ({
    previousPath: undefined,
  }),
  mutations: {
    previousPath: (state, value) => (state.previousPath = value),
  },
  actions: {
    async sync({ commit, rootGetters, state }) {
      commit("previousPath", location.pathname);

      const workspace = rootGetters["switchWorkspace/selected"];
      const organization = rootGetters["organization/selected"];
      const { data } = await rest.post("/sync", { workspace, organization });

      if (!data.organization) {
        if (state.previousPath.startsWith("/management")) {
        } else if (state.previousPath.startsWith("/workspace")) {
        } else if (state.previousPath.startsWith("/account")) {
        } else {
          if (state.previousPath != "/") {
            window.location.href = "/";
          }
        }
        commit("organization/reset", null, { root: true });
      } else {
        commit("organization/selected", data.organization, { root: true });
      }

      commit("switchWorkspace/selected", data.workspace, { root: true });
      commit("user/account", { ...data.account, hasFirmAdminRole: data.hasFirmAdminRole, hasBtAdminRole: data.hasBtAdminRole }, { root: true });
      commit("user/isAdminOrOwnerOfAnyWorkpace", data.isAdminOrOwnerOfAnyWorkpace, { root: true });
      commit("user/accessableRoles", data.accessableRoles, { root: true });
    },
  },
};
